module.exports = __webpack_public_path__ + "static/img/img_shujuzt_jg.d4bd703.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/img_shujuzt_jg.png
// module id = Kct0
// module chunks = 19